<template>
    <div class="company-list">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-11">
                    <div class="title-row">
                        <p class="p-title Raleway p-black"><b>We compare all power companies</b></p>
                        <p class="Raleway min-med p-dgrey">Our goal is to be the best at what we do. <b>TecknaEl.se</b> compares <b>143</b> Sweden's electricity trading companies. Click on a company for more information.</p>
                    </div>
                    <div class="return">
                        <a href="#" class="return_link p-green"><img src="/img/icon/arrow-down-green.svg" alt="">Return to Company List</a>
                    </div>
                    <!--this block may change with block on CompanyList.vue-->
                    <div class="company-info">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="data">
                                    <div class="company__logo">
                                        <img src="/img/telinet.svg" alt="Telinet Energi">
                                    </div>
                                    <div class="info" v-if="isMobile">
                                        <div class="name">
                                            <p class="max-max p-blue">Telinet Energi</p>
                                        </div>
                                        <div class="description">

                                            <p class="min p-light">Cheap, cheap and cheap. Then you can summarize Telinet Energi with three words. For us, the price is everything. At the same time, we never compromise on the environment: all our electricity is green and comes from renewable sources. Welcome to Telinet Energi</p>
                                        </div>
                                    </div>
                                    <div class="address-data">
                                        <p class="min-min"><b>Org. Number:</b> 559171-8522</p>
                                        <p class="min-min"><b>Address:</b> Karlavägen 104, 115 26 Stockholm</p>
                                        <p class="min-min"><b>Turnover:</b> 320 Msek Telinet Energi is the 5 biggest eletricity company of totaly 123 in Sweden.</p>
                                    </div>
                                    <div class="file__list">
                                        <div class="file__item">
                                            <img src="/img/icon/pdf.svg" alt="">
                                            <a href="#" class="min">Contract terms Telinet Energi</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info" v-if="!isMobile">
                                    <div class="name">
                                        <p class="max-max p-blue">Telinet Energi</p>
                                    </div>
                                    <div class="description">

                                        <p class="min p-light">Cheap, cheap and cheap. Then you can summarize Telinet Energi with three words. For us, the price is everything. At the same time, we never compromise on the environment: all our electricity is green and comes from renewable sources. Welcome to Telinet Energi</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--end this block may change with block on CompanyList.vue-->
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "OneCompany",
        data: ()=> {
            return {
                windowWidth: 0,
            }
        },
        methods: {
            handleResize() {
                this.windowWidth = window.innerWidth;
            },


        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
        computed: {
            isMobile: function () {
                if(this.windowWidth > 668){
                    return false;
                } else {
                    return true;
                }

            }
        },
    }

</script>